<script setup>

const props = defineProps({
  // 传入的规则数据
  record: {
    type: Object,
    default: (() => {})
  }
})
</script>

<template>
  <div class="yueBao-rule">
    <div class="yueBao-rule-text" v-html="record?.rule"></div>
    </div>
</template>


<style scoped lang="less">
.yueBao-rule {
  background-color: #fff;
  border-radius: 8px;
  .yueBao-rule-text {
    box-shadow: 0px 1px 2px 1px #76767640;
    margin-bottom: 10px;
    padding: 5px 10px;
    border-radius: 4px;
    font-size: 12px;
    width: 100%;
    // line-height: 24px;
    color: #000;
    &:last-child {
      margin-bottom: 0;
    }
    :deep(p, div, h1, h2, h3, h4, h5, h6, span, li) {
      font-size: inherit;
      margin: 0;
      padding: 0;
      width: 100%;
    }
  }
}
</style>
